import HIGHLIGHT_CONTEXT from "src/context/highlight";
import React from "react";

/** The properties for {@link HighlightTerm} */
type HighlightProps = {
    /** The string to highlight */
    value: string;
};

/**
 * Highlights the current search term in a string.
 */
export function HighlightTerm(props: HighlightProps) {
    const { searchTerm } = React.useContext(HIGHLIGHT_CONTEXT);

    if (searchTerm === "" || searchTerm === undefined) {
        return props.value;
    }

    const searchRegex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "gi");
    const parts = props.value.split(searchRegex);

    return parts.map((part, i) =>
        part.toLowerCase() === searchTerm.toLowerCase() ? (
            <mark key={i} className="-mx-px rounded-xs bg-yellow-200 px-px text-black">
                {part}
            </mark>
        ) : (
            part
        ),
    );
}
